export const PRECHECKOUT_TYPES = {
  PRECHECKOUT_SUCCESS: 'PRECHECKOUT_SUCCESS',
  PRICE_CHANGED: 'PRICE_CHANGED',
  TECH_ERROR: 'TECH_ERROR',
};

export const SOLD_OUT = 'sold_out';
